// 261023 E3-P3i — «Bắt đầu» bấm là chạy luôn (User 26/10: «Bỏ hộp, bấm là chạy luôn»). THUẦN: KHÔNG import antd / react.
// Giá trị gửi = (a) đầu vào đã lưu của truyện nếu có, (b) không thì đúng mặc định hộp cài đặt đang điền sẵn (`defaultStartForm`); số tập để trống (AI đề xuất).
// Body giống HỆT body hộp gửi khi người bấm «Bắt đầu» không sửa gì (cùng `startBodyOf` + cùng `estimateView`), gồm `budgetMode` + `expectedMaxUsd`.
import type { NewStoryEstimate, NewStoryRunStartBody, NewStoryRunStarted } from '../../../services/api/adaptation';
import type { NewStoryRunInputs } from '../../../types/adaptationWorkbench';
import { defaultStartForm, startBodyOf, startFormErrors, StartForm } from './newStoryRunView';
import { estimateView, startErrorView, StartErrorView } from './newStoryBudgetView';

type SavedView = { newStoryRun?: { inputs?: NewStoryRunInputs | null } | null; appendRun?: { kind?: string; inputs?: NewStoryRunInputs | null } | null } | null | undefined;

/** «chưa rõ» là mặc định BE điền khi thể loại trống ⇒ về ô trống (để body giống hộp mặc định). */
const GENRE_UNKNOWN = 'chưa rõ';

/** Đầu vào đã lưu của truyện (chuỗi trước khi lưu khung xương, hoặc đợt NEW_STORY cũ) → form; không có ⇒ mặc định của hộp. */
export const savedStartForm = (v: SavedView): StartForm => {
  const saved = v?.newStoryRun?.inputs ?? (v?.appendRun?.kind === 'NEW_STORY' ? v.appendRun.inputs : null) ?? null;
  const d = defaultStartForm();
  if (!saved) return d;
  const policy = saved.localizePolicy;
  return {
    genre: saved.genre && saved.genre !== GENRE_UNKNOWN ? saved.genre : d.genre,
    episodes: typeof saved.episodes === 'number' ? String(saved.episodes) : d.episodes,
    minutesPerEpisode: typeof saved.minutesPerEpisode === 'number' ? String(saved.minutesPerEpisode) : d.minutesPerEpisode,
    adaptMode: saved.adaptMode ?? d.adaptMode,
    language: saved.language || d.language,
    policyMode: policy?.mode ?? d.policyMode,
    targetCulture: policy?.mode === 'MAP' ? (policy.targetCulture ?? '') : d.targetCulture,
  };
};

export type QuickStartOutcome =
  | { kind: 'busy' }
  | { kind: 'started'; result: NewStoryRunStarted }
  /** Form (đã lưu / mặc định) không qua được kiểm tra ⇒ KHÔNG gửi; người gọi mở hộp với form này để sửa. */
  | { kind: 'invalid'; form: StartForm }
  /** Chưa có điều kiện chạy (ước lỗi / chưa biết) ⇒ KHÔNG gửi. */
  | { kind: 'noEstimate'; text: string }
  | { kind: 'failed'; view: StartErrorView };

export interface QuickStartDeps {
  form: StartForm;
  chapterUnitMax?: number | null;
  estimate: () => Promise<NewStoryEstimate>;
  start: (body: NewStoryRunStartBody) => Promise<NewStoryRunStarted>;
}

/**
 * Bấm «Bắt đầu» một lần. `flight` là cờ chống bấm đôi DÙNG CHUNG giữa các lần bấm (ref): đang bay ⇒ lần bấm sau trả `busy`, KHÔNG gọi ước / gửi thêm. Cờ trả về false khi xong (kể cả lỗi).
 * Thứ tự: kiểm form → ước → gửi. Không kiểm được / ước không có số ⇒ không gửi gì.
 */
export const quickStart = async (flight: { current: boolean }, deps: QuickStartDeps): Promise<QuickStartOutcome> => {
  if (flight.current) return { kind: 'busy' };
  flight.current = true;
  try {
    if (Object.keys(startFormErrors(deps.form, deps.chapterUnitMax)).length > 0) return { kind: 'invalid', form: deps.form };
    let ev = estimateView(undefined);
    try { ev = estimateView(await deps.estimate()); } catch { ev = estimateView(null); }
    const max = ev.button.expectedMaxUsd;
    if (ev.button.disabled || max === null) return { kind: 'noEstimate', text: ev.button.reason ?? '' };
    try {
      return { kind: 'started', result: await deps.start(startBodyOf(deps.form, max)) };
    } catch (e) {
      return { kind: 'failed', view: startErrorView(e) };
    }
  } finally {
    flight.current = false;
  }
};
